import React, { useEffect, useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { generateTranslation } from '../../methods';
import { PasslyCheckbox } from '@app/components';

interface IProps {
    checkValidation: Function;
    methods: string[];
    patchData: IData;
    reset: number;
}

interface IData {
    Type: string;
    RequiresMfa: boolean;
    Methods: string[];
}

export const RequiredMethods = (props: IProps) => {
    const { checkValidation, methods, patchData, reset } = props;
    const { translation } = useTypedTranslation();

    const [requiresPassword, setRequiresPassword] = useState<boolean>(patchData?.RequiresMfa ?? true);
    const [selected, setSelected] = useState<string[]>(patchData?.Methods ?? methods);

    useEffect(() => {
        const data: IData = {
            Type: 'RequiredMethods',
            RequiresMfa: requiresPassword,
            Methods: selected
        };

        checkValidation(true, data);
    }, [requiresPassword]);

    useEffect(() => {
        if (reset > 0) {
            const data: IData = {
                Type: 'RequiredMethods',
                RequiresMfa: requiresPassword,
                Methods: methods
            };

            setSelected(methods);
            checkValidation(true, data);
        }
    }, [reset]);

    const checkSelection = (method: string): boolean => {
        return selected.includes(method);
    };

    const selectMethod = (method: string) => () => {
        const temp: string[] = selected;
        let selectedNew = [...temp, method];

        if (temp.some((item: string) => method === item)) {
            selectedNew = [...temp.filter((item: string) => method !== item)];
        }

        setSelected(selectedNew);

        const data: IData = {
            Type: 'RequiredMethods',
            RequiresMfa: requiresPassword,
            Methods: selectedNew
        };

        checkValidation(true, data);
    };
    const changIsRequiresPassword = () => setRequiresPassword(!requiresPassword);

    return (
        <div className='authMethods'>
            <PasslyCheckbox
                name='require2FA'
                checked={requiresPassword}
                onChange={changIsRequiresPassword}
                label={translation('AUTH_POLICY_REQUIRE_MFA')}
            />

            {requiresPassword && (
                <>
                    <h4 className='authMethods__header'>{translation('AUTH_POLICY_SUPPORTED_MFA_METHODS')}</h4>
                    <ul className='authMethods__list'>
                        {methods.map((method: string, index: number) => (
                            <li key={index}>
                                <PasslyCheckbox
                                    name=''
                                    checked={checkSelection(method)}
                                    onChange={selectMethod(method)}
                                    label={generateTranslation(method)}
                                />
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};
